export const state = () => {
	return {
		challenges: [],
		challenge: {},
		ttl_challenges: null,
		ttl_challenge: null,
		cache_duration_challenges: 3600000, // 1 hour
		cache_duration_challenge: 3600000, // 1 hour
		cache_key_challenges: '',
		cache_key_challenge: '',
	}
}

function isInCacheChallenges(state, companyId) {
	if (state.cache_key_challenges !== buildCacheKeyChallenges(companyId)) {
		return false
	}
	if (state.ttl_challenges === null || state.ttl_challenges < Date.now()) {
		return false
	}
	return true
}

function isInCacheChallenge(state, companyId, challengeId) {
	if (state.cache_key_challenge !== buildCacheKeyChallenge(companyId, challengeId)) {
		return false
	}
	if (state.ttl_challenge === null || state.ttl_challenge < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyChallenges(companyId) {
	return `company:${companyId}:loyalty-challengees`
}

function buildCacheKeyChallenge(companyId, challengeId) {
	return `company:${companyId}:loyalty-challengees:${challengeId}`
}

export const actions = {
	async list({ state, commit }, { companyId }) {
		if (isInCacheChallenges(state, companyId)) {
			return state.challenges
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/loyalty/challenges/`)
			.then((res) => {
				commit('setChallenges', { data: res, companyId })
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async retrieve({ state, commit }, { companyId, challengeId }) {
		if (isInCacheChallenge(state, companyId, challengeId)) {
			return state.challenge
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/loyalty/challenges/${challengeId}/`)
			.then((res) => {
				commit('setChallenge', { data: res, companyId, challengeId })
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	partialUpdate({ commit, dispatch }, { companyId, challengeId, data }) {
		return useNuxtApp()
			.$api(`api/company/${companyId}/loyalty/challenges/${challengeId}/`, {
				method: 'PATCH',
				body: data,
			})
			.then((res) => {
				commit('invalidateCacheChallenges')
				commit('invalidateCacheChallenge')
				dispatch('list', { companyId })
			})
	},

	async create({ state, commit }, { companyId, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/loyalty/challenges/`, {
				method: 'POST',
				body: data,
			})
			.then((res) => {
				commit('setChallenges', { data: [res], companyId })
			})
	},

	async createDefault({ state, commit }, { companyId, defaultName }) {
		const data = {
			company: companyId,
			enable: false,
			name: defaultName,
			type: 0,
			points_value: 5,
			allocation_days: 0,
			icon_url: 'https://assets.loyoly.io/public/icons/loyalty.png',
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/loyalty/challenges/`, {
				method: 'POST',
				body: data,
			})
			.then((res) => {
				commit('setChallenges', { data: [res], companyId })
			})
	},
}

export const mutations = {
	setChallenges(state, { data, companyId }) {
		state.challenges = data
		state.ttl_challenges = Date.now() + state.cache_duration_challenges
		state.cache_key_challenges = buildCacheKeyChallenges(companyId)
	},

	invalidateCacheChallenges(state) {
		state.ttl_challenges = null
		state.cache_duration_challenges = ''
	},

	setChallenge(state, { data, companyId, challengeId }) {
		state.challenge = data
		state.ttl_challenge = Date.now() + state.cache_duration_challenge
		state.cache_key_challenge = buildCacheKeyChallenges(companyId, challengeId)
	},

	invalidateCacheChallenge(state) {
		state.ttl_challenge = null
		state.cache_duration_challenge = ''
	},
}
